import mountains from "../../assets/stories/desktop/mountains.jpg";
import cityscapes from "../../assets/stories/desktop/cityscapes.jpg";
import daysvoyage from "../../assets/stories/desktop/18-days-voyage.jpg";
import architecturals from "../../assets/stories/desktop/architecturals.jpg";

import mountainsMobile from "../../assets/stories/mobile/mountains.jpg";
import cityscapesMobile from "../../assets/stories/mobile/cityscapes.jpg";
import daysvoyageMobile from "../../assets/stories/mobile/18-days-voyage.jpg";
import architecturalsMobile from "../../assets/stories/mobile/architecturals.jpg";

import worldtour from "../../assets/stories/desktop/world-tour.jpg";
import unforeseen from "../../assets/stories/desktop/unforeseen-corners.jpg";
import king from "../../assets/stories/desktop/king-on-africa.jpg";
import trip from "../../assets/stories/desktop/trip-to-nowhere.jpg";
import rage from "../../assets/stories/desktop/rage-of-the-sea.jpg";
import running from "../../assets/stories/desktop/running-free.jpg";
import waves from "../../assets/stories/desktop/behind-the-waves.jpg";
import calm from "../../assets/stories/desktop/calm-waters.jpg";
import milky from "../../assets/stories/desktop/milky-way.jpg";
import forest from "../../assets/stories/desktop/dark-forest.jpg";
import somwarpet from "../../assets/stories/desktop/somwarpet.jpg";
import land from "../../assets/stories/desktop/land-of-dreams.jpg";

import worldtourMobile from "../../assets/stories/mobile/world-tour.jpg";
import unforeseenMobile from "../../assets/stories/mobile/unforeseen-corners.jpg";
import kingMobile from "../../assets/stories/mobile/king-on-africa.jpg";
import tripMobile from "../../assets/stories/mobile/trip-to-nowhere.jpg";
import rageMobile from "../../assets/stories/mobile/rage-of-the-sea.jpg";
import runningMobile from "../../assets/stories/mobile/running-free.jpg";
import wavesMobile from "../../assets/stories/mobile/behind-the-waves.jpg";
import calmMobile from "../../assets/stories/mobile/calm-waters.jpg";
import milkyMobile from "../../assets/stories/mobile/milky-way.jpg";
import forestMobile from "../../assets/stories/mobile/dark-forest.jpg";
import somwarpetMobile from "../../assets/stories/mobile/somwarpet.jpg";
import landMobile from "../../assets/stories/mobile/land-of-dreams.jpg";

export const FeaturesData = [
	{
		date: "April 16th 2020",
		cName: "cards__item",
		src: mountains,
		srcSet: mountainsMobile,
		title: "The Mountains",
		prod: "John Appleseed",
		button: "read story",
	},
	{
		date: "April 14th 2020",
		cName: "cards__item",
		src: cityscapes,
		srcSet: cityscapesMobile,
		title: "Sunset Cityscapes",
		prod: "Benjamin Cruz",
		button: "read story",
	},
	{
		date: "April 11th 2020",
		cName: "cards__item",
		src: daysvoyage,
		srcSet: daysvoyageMobile,
		title: "18 Days Voyage",
		prod: "Alexei Borodin",
		button: "read story",
	},
	{
		date: "April 9th 2020",
		cName: "cards__item",
		src: architecturals,
		srcSet: architecturalsMobile,
		title: "Architecturals",
		prod: "Samantha Brooke",
		button: "read story",
	},
	{
		date: "April 7th 2020",
		cName: "cards__item",
		src: worldtour,
		srcSet: worldtourMobile,
		title: "World Tour",
		prod: "Timothy Wagner",
		button: "read story",
	},
	{
		date: "April 3rd 2020",
		cName: "cards__item",
		src: unforeseen,
		srcSet: unforeseenMobile,
		title: "Unforeseen Corners",
		prod: "William Malcolm",
		button: "read story",
	},
	{
		date: "March 29th 2020",
		cName: "cards__item",
		src: king,
		srcSet: kingMobile,
		title: "King on Africa: Part II",
		prod: "Tim Hillenburg",
		button: "read story",
	},
	{
		date: "March 21st 2020",
		cName: "cards__item",
		src: trip,
		srcSet: tripMobile,
		title: "The Trip to Nowhere",
		prod: "Felicia Rourke",
		button: "read story",
	},
	{
		date: "March 19th 2020",
		cName: "cards__item",
		src: rage,
		srcSet: rageMobile,
		title: "Rage of The Sea",
		prod: "Mohammed Abdul",
		button: "read story",
	},
	{
		date: "March 16th 2020",
		cName: "cards__item",
		src: running,
		srcSet: runningMobile,
		title: "Running Free",
		prod: "Michelle",
		button: "read story",
	},
	{
		date: "March 11th 2020",
		cName: "cards__item",
		src: waves,
		srcSet: wavesMobile,
		title: "Behind the Waves",
		prod: "Lamarr Wilson",
		button: "read story",
	},
	{
		date: "March 9th 2020",
		cName: "cards__item",
		src: calm,
		srcSet: calmMobile,
		title: "Calm Waters",
		prod: "Samantha Brooke",
		button: "read story",
	},
	{
		date: "March 5th 2020",
		cName: "cards__item",
		src: milky,
		srcSet: milkyMobile,
		title: "The Milky Way",
		prod: "Benjamin Cruz",
		button: "read story",
	},
	{
		date: "March 4th 2020",
		cName: "cards__item",
		src: forest,
		srcSet: forestMobile,
		title: "Night at The Dark Forest",
		prod: "Mohamemd Abdul",
		button: "read story",
	},
	{
		date: "March 1st 2020",
		cName: "cards__item",
		src: somwarpet,
		srcSet: somwarpetMobile,
		title: "Somwarpet's Beauty",
		prod: "Michelle",
		button: "read story",
	},
	{
		date: "February 25th 2020",
		cName: "cards__item",
		src: land,
		srcSet: landMobile,
		title: "William Malcolm",
		prod: "Michelle",
		button: "read story",
	},
];

export const CardData = [
	{
		cName: "cards__item",
		src: mountains,
		srcSet: mountainsMobile,
		title: "The Mountains",
		prod: "by John Appleseed",
		button: "read the story",
	},
	{
		cName: "cards__item",
		src: cityscapes,
		srcSet: cityscapesMobile,
		title: "Sunset Cityscapes",
		prod: "by Benjamin Cruz",
		button: "read the story",
	},
	{
		cName: "cards__item",
		src: daysvoyage,
		srcSet: daysvoyageMobile,
		title: "18 Days Voyage",
		prod: "by Alexei Borodin",
		button: "read the story",
	},
	{
		cName: "cards__item",
		src: architecturals,
		srcSet: architecturalsMobile,
		title: "Architecturals",
		prod: "by Samantha Brooke",
		button: "read the story",
	},
];
